import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  quantity: {
    defaultMessage: 'Qty: {quantity}',
    description: 'Text for the quantity field in the return outcome summary',
    id: 'tPw92I',
  },
});
